<template>
  <div class="depList">
    <HearderTitle name="项目管理" />
    <div class="tableBox">
      <div class="tool_bar">
        <el-form :inline="true">
          <el-form-item style="float: right">
            <el-button class="lightBlueBtn" type="primary" size="small" @click="add()">添加项目</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="table">
        <el-table ref="refTable" header-cell-class-name="h_bg" :data="tableData" style="width: 100%">
          <el-table-column prop="did" label="ID号" width="180" align="center"> </el-table-column>
          <el-table-column prop="dname" label="名称" align="center"> </el-table-column>
          <el-table-column prop="sort" label="排序" align="center"> </el-table-column>
          <el-table-column label="操作" align="center" width="258">
            <template slot-scope="scope">
              <div class="table_btns">
                <el-button @click="show(scope.row)" size="mini">编辑</el-button>
                <el-button size="mini" @click="del(scope.row.did)" class="warning">删除</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-dialog class="depDialog" ref="depDialog" :modal="false" :title="depDialogTitle" @close="closeDialig()" :visible.sync="depDialog" width="435px">
      <el-form ref="dep" :rules="rules" :model="depData" label-width="80px">
        <el-form-item label="名称" prop="dname">
          <el-input type="text" v-model="depData.dname" autofocus></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input type="sort" v-model="depData.sort"></el-input>
        </el-form-item>
        <el-form-item>
          <input type="text" v-model="depData.did" hidden />
          <el-button class="lightBlueBtn searchBtn" type="primary" size="small" @click="seve()">提交</el-button>
          <el-button size="small" plain class="searchBtn" @click="depDialog = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
  import { addDep, deleteDep, depList, editDep } from '@/api/user.js'
  import HearderTitle from '@/components/HearderTitle'
  export default {
    name: 'depList',
    data() {
      return {
        depDialogTitle: '新增项目',
        tableData: [],
        depDialog: false,
        depData: {
          dname: '',
          did: '',
          sort: null,
        },
        rules: {
          dname: [{ required: true, message: '项目不能为空', trigger: 'blur' }],
          sort: [
            { required: true, message: '排序不能为空', trigger: 'blur' },
            // { type: 'number', message: '排序必须为数字', trigger: 'blur' },
          ],
        },
      }
    },
    created() {
      this.getdepList()
    },
    components: { HearderTitle },
    methods: {
      // 获取项目列表
      async getdepList() {
        let { list } = await depList()
        this.tableData = list
      },
      add() {
        this.depDialogTitle = '新增项目'
        this.depDialog = true
      },
      // 删除项目
      async del(did) {
        if (!did) return this.$message.error('请选择要删除的数据')
        const res = await this.$confirm('您确定删除该项目吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).catch((err) => err)
        if (res !== 'confirm') return this.$message.info('取消成功')
        let response = await deleteDep({ did })
        if (response.status !== 200) {
          this.$message.error('删除失败')
        } else {
          this.$message.success('删除成功')
          // 删除成功后刷新页面
          this.getdepList()
        }
      },
      // 显示修改状态弹窗
      show(data) {
        this.depDialogTitle = '修改项目'
        this.depData.dname = data.dname
        this.depData.did = data.did
        this.depData.sort = data.sort
        this.depDialog = true
      },
      async seve() {
        this.$refs['dep'].validate(async (valid) => {
          if (!valid) return
          let res = {}
          let { dname, sort, did } = this.depData
          if (this.depData.did === '') {
            res = await addDep({ dname, sort, did })
          } else {
            res = await editDep({ dname, sort, did })
            this.depData.dname = ''
            this.depData.did = ''
            this.depData.sort = null
          }
          if (res.status !== 200) return this.$message.error(res.msg)
          this.$message.success('提交成功')
          this.closeDialig()
          this.$refs['dep'].resetFields()
          this.depDialog = false
          return this.getdepList()
        })
      },
      closeDialig() {
        this.depData.dname = ''
        this.depData.did = ''
        this.depData.sort = null
      },
    },
  }
</script>

<style lang="less">
  .depList {
    .tableBox {
      .table .table_btns .el-button.max {
        width: 68px;
      }
      .select {
        color: #015293;
        font-size: 12px;
        cursor: pointer;
      }
      .tool_bar {
        overflow: hidden;
        padding-top: 18px;
        padding-bottom: 18px;
        font-size: 14px;
        color: #888;
        .el-form-item {
          margin-right: 0;
          margin-bottom: 0;
          .el-input__inner {
            width: 210px;
            height: 32px;
          }
          .el-input__inner {
            padding-left: 10px;
          }
          .middle {
            padding: 0 10px;
          }
          .searchBtn {
            width: 82px;
          }
        }
      }
      .el-table {
        min-height: 685px;
        &::before {
          height: 0;
        }
      }
    }
  }
  .depDialog {
    .el-dialog__header {
      border-bottom: 1px solid #dcdfe6;
    }
    .el-dialog__body {
      padding-bottom: 0;
      overflow: hidden;
      .el-form-item {
        margin-bottom: 20px;
      }
    }
    .el-date-editor.el-input,
    .el-date-editor.el-input__inner,
    .el-textarea__inner {
      width: 300px;
    }
    .el-input__inner {
      padding-left: 15px;
      width: 300px;
    }
    .searchBtn {
      width: 112px;
    }
  }
</style>
